import { isNull } from "lodash";
import { LoadingDots } from "PFComponents/loading_dots";
import React from "react";
import { useTranslation } from "react-i18next";

import { IDataItem } from "../types";
import { AddButton } from "./actions";
import css from "./section.module.scss";
import ThresholdsTable from "./thresholds_table";

const MAX_THRESHOLDS_PER_LIST = 10;

interface ISectionProps {
  kind: string;
  title: string;
  data: IDataItem[];
  setOpenColorsModal: (IDataItem) => void;
  setData: React.Dispatch<React.SetStateAction<IDataItem[]>>;
  loading: boolean;
  editedRowKey: string | null;
  setEditedRowKey: (string) => void;
  editedColorItem: IDataItem | null;
  setEditedColorItem: (any) => void;
  onConfigUpdate?: () => void;
}

const Section = ({
  kind,
  title,
  data,
  setOpenColorsModal,
  setData,
  loading,
  editedRowKey,
  setEditedRowKey,
  editedColorItem,
  setEditedColorItem,
  onConfigUpdate
}: ISectionProps) => {
  const { t } = useTranslation("bookingModule");

  const hasThresholds = data.length > 0;

  return (
    <div className={css.wrapper}>
      <div className={css.header}>
        {title}
        <span>
          <AddButton
            disabled={data.length >= MAX_THRESHOLDS_PER_LIST || !isNull(editedRowKey)}
            setAddNewInSection={setData}
            kind={kind}
          />
        </span>
      </div>
      {hasThresholds ? (
        <>
          <div className={css.table}>
            {loading ? (
              <LoadingDots circlesEnabled pageViewEnabled />
            ) : (
              <ThresholdsTable
                data={data}
                onColorEdit={setOpenColorsModal}
                setData={setData}
                kind={kind}
                setEditedRowKey={setEditedRowKey}
                editedRowKey={editedRowKey}
                editedColorItem={editedColorItem}
                setEditedColorItem={setEditedColorItem}
                onConfigUpdate={onConfigUpdate}
              />
            )}
          </div>
        </>
      ) : (
        <div className={css.addNew}>{t("config.thresholds.addNewThresholds")}</div>
      )}
    </div>
  );
};

export default Section;
